import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/vilicvane/projects/makeflow/boring-router/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <p>{`Boring Router is a state-first router with light-weight route components. It manages observable (MobX) route states like `}<inlineCode parentName="p">{`route.$matched`}</inlineCode>{` and `}<inlineCode parentName="p">{`route.$params`}</inlineCode>{`, so the route components as well as your code can react to those states. Boring Router is written in TypeScript and it puts type safety in mind designing the API.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Check out examples `}<a parentName="p" {...{
          "href": "/boring-router/examples"
        }}>{`here`}</a>{`.`}</p>
    </blockquote>
    <h2 {...{
      "id": "route-notation"
    }}>{`Route Notation`}</h2>
    <p>{`Boring Router uses schema-based, type-safe route notation. You don't need, and it is not recommended to write routes as strings with Boring Router.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const route = router.$route({
  $children: {
    workbench: {
      $children: {
        taskId: {
          $match: /\\d+/,
        },
      },
    },
  },
});
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<Route match={route.workbench.taskId} component={WorkbenchTaskView} />
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<Link to={route.workbench.taskId} params={{taskId: '123'}}>
  Go to Task
</Link>
`}</code></pre>
    <p>{`Route schema can be shared with Node.js backend and this makes route notations type-safe everywhere.`}</p>
    <h2 {...{
      "id": "parallel-routes"
    }}>{`Parallel Routes`}</h2>
    <p>{`Views like sidebar, overlay can be easily routed with Boring Router parallel routes.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const route = router.$route({
  /* primary route schema */
});

const sidebarRoute = router.$route('sidebar', {
  /* sidebar route schema */
});
`}</code></pre>
    <p>{`URL for parallel routes looks like `}<inlineCode parentName="p">{`/workbench?_sidebar=/notifications`}</inlineCode>{`, and additional parallel routes work just like primary route in most cases.`}</p>
    <h2 {...{
      "id": "lifecycle-hooks"
    }}>{`Lifecycle Hooks`}</h2>
    <p>{`Boring Router supports `}<inlineCode parentName="p">{`before/will/after`}</inlineCode>{` x `}<inlineCode parentName="p">{`enter/update/leave`}</inlineCode>{` hooks.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`route.workbench.$beforeEnter(async next => {
  let {referrer} = next.$params;

  if (await testReferrer(referrer)) {
    return;
  }

  route.$replace();
});
`}</code></pre>
    <p>{`To support full lifecycle hooks while keeping history navigation behavior right, Boring Router implements its own `}<inlineCode parentName="p">{`BrowserHistory`}</inlineCode>{` with the ability to restore browser history stack according to a given snapshot.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Check out an example `}<a href="https://codesandbox.io/s/github/makeflow/boring-router/tree/master/packages/examples/lifecycle-hooks?file=/main.tsx&amp;expanddevtools=1" target="_blank">{`here`}</a>{`.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      